import { render, staticRenderFns } from "./workspace-bulk-invite.vue?vue&type=template&id=5db9403c&"
import script from "./workspace-bulk-invite.vue?vue&type=script&lang=js&"
export * from "./workspace-bulk-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports